import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { isNative } from './platform';

export function isNativeScanAvailable(): boolean {
  return isNative();
}

/**
 * Open the native camera scanner. Resolves to the scanned string, or null
 * if user cancelled / permission denied. The scanner covers the WebView
 * with a transparent camera view, so callers must hide their own UI while
 * scanning and restore it on the returned promise.
 */
export async function scanOnce(): Promise<string | null> {
  if (!isNative()) return null;

  const perm = await BarcodeScanner.checkPermission({ force: true });
  if (!perm.granted) return null;

  document.body.classList.add('native-scan-active');
  await BarcodeScanner.hideBackground();
  try {
    const result = await BarcodeScanner.startScan();
    if (result.hasContent) return result.content ?? null;
    return null;
  } finally {
    await BarcodeScanner.showBackground();
    await BarcodeScanner.stopScan();
    document.body.classList.remove('native-scan-active');
  }
}

export async function cancelScan(): Promise<void> {
  if (!isNative()) return;
  try {
    await BarcodeScanner.showBackground();
    await BarcodeScanner.stopScan();
  } catch {
    /* nothing to cancel */
  }
  document.body.classList.remove('native-scan-active');
}
